var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('client-only',[_c('CaptchaClient',_vm._b({ref:"captcha",on:{"solved":_vm.onPuzzleSolved}},'CaptchaClient',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }